<p>forgot-new-password works!</p>
